import { A } from '@adornis/base/env-info.js';
import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-card.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-icon.js';
import '@adornis/chemistry/elements/components/x-link.js';
import '@adornis/chemistry/elements/components/x-section.js';
import '@adornis/popover/x-dropdown.js';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

/**
 * @element bh-footer
 */
@customElement('bh-footer')
export class BHFooter extends BuchungsheldLitElement {
  @property({ attribute: 'institution-id' }) _institutionID?: string;
  @state() private readonly size = new WindowSizeController(this);

  get institutionID() {
    if (this._institutionID) return this._institutionID!;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get('institution')) return urlParams.get('institution');

    return null;
  }

  override render() {
    if (this.isInIframe()) {
      return nothing;
    }

    return html`
      <x-section>
        ${(() => {
          if (this.size.mobile)
            return html`
              <x-flex vertical crossaxis-center end space="sm" ${css({ padding: `${this.spacing.md} 0` })}>
                ${this.links()}
              </x-flex>
            `;
          else
            return html`
              <x-flex horizontal crossaxis-center end space="sm" ${css({ padding: `${this.spacing.md} 0` })}>
                ${this.links()}
              </x-flex>
            `;
        })()}
      </x-section>
    `;
  }

  private isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  private links() {
    const link = (val: string) => {
      const institutionID = this.institutionID;
      return institutionID ? A.absoluteUrl(`/${val}?institution=${institutionID}`) : A.absoluteUrl(`/${val}`);
    };

    return [
      { path: 'impressum', label: this._translation.translate('imprint') },
      { path: 'datenschutz', label: this._translation.translate('privacy') },
      { path: 'terms', label: this._translation.translate('termsOfUse') },
      { path: 'barrierefreiheit', label: this._translation.translate('accessibility') },
    ].map(({ path, label }) => html`<x-link href=${link(path)}> <x-text tone="subtle"> ${label} </x-text> </x-link>`);
  }
}
